import TrialBalanceWorkFlow from 'models/api/trial-balance/trial-balance-workflow-model';
import { handleActions } from 'redux-actions';
import {
  resetTrailBalanceWorkFlowStatus,
  trailBalanceWorkFlowStatusError,
  trailBalanceWorkFlowStatusLoaded,
  trailBalanceWorkFlowStatusLoading,
  omniaTBUpdateAlert,
} from 'store/actions/trial-balance/trial-balance-action';

export default handleActions(
  {
    [trailBalanceWorkFlowStatusLoaded]: (trailBalanceWorkFlow, { payload }) => {
      return trailBalanceWorkFlow.setLoaded(payload);
    },
    [trailBalanceWorkFlowStatusLoading]: (trailBalanceWorkFlow) => {
      return trailBalanceWorkFlow.setLoading();
    },
    [trailBalanceWorkFlowStatusError]: (trailBalanceWorkFlow, { error }) => {
      return trailBalanceWorkFlow.setError(error);
    },
    [resetTrailBalanceWorkFlowStatus]: () => {
      return new TrialBalanceWorkFlow();
    },
    [omniaTBUpdateAlert]: (trailBalanceWorkFlow) => {
      return trailBalanceWorkFlow.omniaTBUpdateAlert();
    },
  },
  new TrialBalanceWorkFlow(),
);
